import { render, staticRenderFns } from "./SendSms.vue?vue&type=template&id=32df243e&scoped=true"
import script from "./SendSms.vue?vue&type=script&lang=js"
export * from "./SendSms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32df243e",
  null
  
)

export default component.exports